var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"dotdotdot"},[_c('div',{staticClass:"dot dot1",class:{ 'dot--inverted': _vm.invertColor }}),_c('div',{staticClass:"dot dot2",class:{ 'dot--inverted': _vm.invertColor }}),_c('div',{staticClass:"dot dot3",class:{ 'dot--inverted': _vm.invertColor }})])
}
var staticRenderFns = []

export { render, staticRenderFns }